const stringify = value => {
  if (typeof value === 'object') {
    return JSON.stringify(value)
  }
  return String(value)
}

const parse = value => {
  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}

export const get = (key, defaultValue) => {
  // https://michalzalecki.com/why-using-localStorage-directly-is-a-bad-idea/#securityerror-the-operation-is-insecure
  // looks like Safari will throw error when user is blocking all cookies in security settings,
  // cookies and localStorage share the same settings
  try {
    const item = window.localStorage.getItem(key)
    if (!item) return defaultValue
    return parse(item)
  } catch (error) {
    return defaultValue
  }
}

export const set = (key, value) => {
  try {
    window.localStorage.setItem(key, stringify(value))
  } catch (error) {
    // do nothing
  }
}

export const remove = key => {
  try {
    window.localStorage.removeItem(key)
  } catch (error) {
    // do nothing
  }
}
